import fullListingDtos from './versions/full-listing-dtos'
import legacy from './versions/legacy'

export default {
  '1.0.0': legacy,
  '1.5.0': fullListingDtos,
  '1.5.1': fullListingDtos,
  '1.5.2': fullListingDtos,
  '1.5.3': fullListingDtos,
  '1.5.4': fullListingDtos
}
